/**
 * Bridge "I clicked the Google button as a teacher signup" intent through
 * the OAuth round-trip so the backend can create the new user with the
 * right role. NextAuth's signIn() doesn't carry arbitrary state across the
 * Google redirect, so we stash the intent in a short-lived cookie that is
 * read by the signIn callback after Google sends the user back.
 *
 * Set by the marketing pages /teach and /learn and by /auth?role=...
 * before triggering Google OAuth. Only honored on first-time user creation;
 * ignored for existing users.
 */

export const SIGNUP_ROLE_HINT_COOKIE = "rawiah_signup_role";

/**
 * Set on the click handler of a Google signup button. Lasts 5 min — enough
 * for the slowest OAuth flow but short enough that it can't bleed into a
 * later, unrelated sign-in attempt.
 */
export function setSignupRoleHint(role: "STUDENT" | "TEACHER"): void {
  if (typeof document === "undefined") return;
  document.cookie = `${SIGNUP_ROLE_HINT_COOKIE}=${role}; path=/; max-age=300; SameSite=Lax`;
}
